/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunityListEntitiesResponse
 */
export interface OpportunityListEntitiesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof OpportunityListEntitiesResponse
     */
    entities: Array<string>;
}

/**
 * Check if a given object implements the OpportunityListEntitiesResponse interface.
 */
export function instanceOfOpportunityListEntitiesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entities" in value;

    return isInstance;
}

export function OpportunityListEntitiesResponseFromJSON(json: any): OpportunityListEntitiesResponse {
    return OpportunityListEntitiesResponseFromJSONTyped(json, false);
}

export function OpportunityListEntitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityListEntitiesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entities': json['entities'],
    };
}

export function OpportunityListEntitiesResponseToJSON(value?: OpportunityListEntitiesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entities': value.entities,
    };
}

